import { LowStockNotificationModels } from '@getgreenline/inventory'
import React from 'react'

interface Props {
  recipients?: LowStockNotificationModels.ILowStockNotificationRecipient[]
  deleteRecipient: (id: number) => void
}

const LowStockAlertRecipients = ({ recipients, deleteRecipient }: Props): JSX.Element => {
  if (!recipients || !Array.isArray(recipients) || recipients.length === 0) {
    return <div className='text-muted'>No alerts set up yet</div>
  }

  return (
    <div>
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th>Location</th>
            <th>Added by</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {recipients.map((recipient) => (
            <tr key={recipient.id}>
              <td className='text-muted'>{recipient.locationName}</td>
              <td className='text-muted'>{recipient.userName}</td>
              <td>
                <a onClick={() => deleteRecipient(recipient.id)}>
                  <span className='fa fa-times ml-2' />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default LowStockAlertRecipients
